import { useCallback, useState } from "react";

import { copyTextToClipboard } from "@tma.js/sdk-react";

import { haptic } from "shared/utils/tg";

export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback(
    async (value: string) => {
      try {
        await copyTextToClipboard(value);
        haptic("light");
        setIsCopied(true);
      } catch (error) {
        console.error(error);
      }

      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    },
    [setIsCopied]
  );

  return { copy, isCopied };
};
